import 'style/globals.css'

import { ConfigProvider } from 'antd'
import ruRU from 'antd/locale/ru_RU'
import { LocalityProvider } from 'location/LocalityProvider'
import type { AppProps } from 'next/app'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { generalTheme } from 'style'
import { ThemeProvider } from 'styled-components'

import MainContainer from '../MainContainer'
import store, { persistor } from '../store/store'

const App = ({ Component, pageProps }: AppProps) => (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <ConfigProvider locale={ruRU}>
        <ThemeProvider theme={generalTheme}>
          <LocalityProvider>
            <MainContainer>
              <Component {...pageProps} />
            </MainContainer>
          </LocalityProvider>
        </ThemeProvider>
      </ConfigProvider>
    </PersistGate>
  </Provider>
)
export default App
